// export const fetchCategories = async () => {
//     try {
//       const response = await fetch("https://tsoministries.com/wp-json/wp/v2/attachment_category");
//       const data = await response.json();
//       const newData = data.map((value) => {value.id, value.count, value.description, value.name, value.slug})
//       return data.reduce((acc, category) => {
//         acc[category.id] = category.name; // Map ID to name
//         return newData;
//       }, {});
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       return {};
//     }
//   };

export const fetchCategories = async () => {
    try {
      const response = await fetch("https://tsoministries.com/wp-json/wp/v2/attachment_category");
      const data = await response.json();
  
      const newData = data.map((value) => ({
        id: value.id,
        name: value.name,
        imageUrl: value.meta?.category_image_url || "", // Custom field
        eventDate: value.meta?.category_event_date || "",
        location: value.meta?.category_location || "",
        tags: value.meta?.category_tags ? value.meta.category_tags.split(",").map(tag => tag.trim()) : [], // Convert to array
        // tags: value.meta?.category_tags ? value.meta.category_tags.split(",").map(tag => tag.trim()) : [], // Convert to array
      }));
  
      return newData;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };


    // const fetchCategories = async () => {
  //   const response = await fetch("https://yourwordpresssite.com/wp-json/wp/v2/categories");
  //   const data = await response.json();
  //   console.log(data);
  // };

  // const fetchTags = async () => {
  //   const response = await fetch("https://yourwordpresssite.com/wp-json/wp/v2/tags");
  //   const data = await response.json();
  //   console.log(data);
  // };